import React from 'react'
import { Button, Result } from 'antd'
import { Link } from 'react-router-dom'
import Routes from '../../constants/routes'
import { useDocumentTitle } from '../../hooks/useDocumentTitle'

const AccessDeniedPage = () => {
    useDocumentTitle('Access denied')

    return (
        <div className='d-flex-center vh-100'>
            <Result
                status='403'
                title='Access forbidden'
                subTitle='You tried to access a page you did not have prior authorization for.'
                extra={
                    <Link to={Routes.HOME}>
                        <Button type='primary'>Back to home</Button>
                    </Link>
                }
            />
        </div>
    )
}

export default AccessDeniedPage
